import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit } from '@angular/core';
import { ExcelUtils } from '../lib/Excel';

@Component({
    selector: 'app-workbook-functions',
    templateUrl: './workbook-functions.component.html',
    styleUrls: ['./workbook-functions.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    standalone: true
})
export class WorkbookFunctionsComponent implements AfterViewInit {

    constructor(private el: ElementRef<HTMLElement>) { }

    ngAfterViewInit(): void {
        // // componentHandler.upgradeAllRegistered(this.el.nativeElement);
    }

    async toggleWorkbookTabs() {
        await ExcelUtils.run(async context => {
        });
    }
}
